import React, { useEffect, useLayoutEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Button, ButtonGroup, Card, CircularProgress, Grid, Hidden, Typography } from '@material-ui/core';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, ComposedChart } from 'recharts';
import { PieChart, Pie, Sector, LabelList } from 'recharts';
import { Wifi } from '@material-ui/icons';
import './mainDashboard.scss';
import { useHistory } from 'react-router-dom';
import { SecondaryButton } from '../FormInput';
import { useWindowSize } from '../Controls/ScreenResolution';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { ColorsDash, setObject, timenumber } from './color';
import JobByTechnician from './BaseComp/JobByTech';
import PartReqCommon from './BaseComp/PartReq';
import Inspections from './BaseComp/Inspections';
import { EWIPDates } from './BaseComp/wip-date';
import { WipDashboardHours } from './BaseComp/wipDash-Hours';
import { WipDashboardTechnician } from './BaseComp/wipDash-Technician';
import WipDashboardBranch from './BaseComp/wipDash-Branch';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        margin: 0,
        boxSizing: 'border-box',
        border: '1px solid #e2e8f0',
        minWidth: 120,
        padding: '12px 16px',
        background: '#ffffff',
        borderRadius: 5,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
        '&:hover': {
            boxShadow: '0 4px 14px rgba(0, 0, 0, 0.08)',
            borderColor: '#cbd5e1'
        }
    }
}));

const DashboardCharts = (props) => {
    const { state } = props;
    const classes = useStyles();
    const history = useHistory();
    const [array, setArray] = useState({
        workflowReturnReasonArray: [],
        keys: [],
        byTimeObj: {},
        selectRRarr: [],
        showLoader: true,
        selectedFilterTechData: [],
        techJobsTotal: 0,
        hourType: 'remaining',
        assignedDate: 2,
        assignedJobs: [],
        selectedPieChartType: 'A',
        byAssignedUser: 'Default',
        assignedJobsTotals: 0
        // partReqBranchId: JSON.parse(localStorage.getItem('_dashboard_')).branchID ? JSON.parse(localStorage.getItem('_dashboard_')).branchID : null
    });

    const [width, height] = useWindowSize();

    useEffect(() => {
        let btTimeData = JSON.parse(localStorage.getItem('FiltterParams'));

        if (btTimeData?.branchShortName) {
            props.getbranchByOnchange(btTimeData?.branchShortName);
        } else {
            props.getbranchByOnchange('Default');
        }
    }, []);

    useEffect(() => {
        if (state.sumOFByTimeForALL) {
            let btTimeData = JSON.parse(localStorage.getItem('FiltterParams'));
            if (state.sumOFByTimeForALL) {
                findByTimeValues(btTimeData?.branchShortName || 'Default');
            }
        }
    }, [state.sumOFByTimeForALL]);

    useEffect(() => {
        let tempData = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        let btTimeData = JSON.parse(localStorage.getItem('FiltterParams'));
        localStorage.setItem('FiltterParams', JSON.stringify({ ...btTimeData, branchTime: '' }));

        if (state) {
            if (state.workFlowDataBarData) {
                pullWorkflowRRdata(tempData.workflowReturnReason || state.workFlowDataBarData[0]?.workflow);
            }

            if (state.chartdata) {
                setArray((st) => ({
                    ...st,
                    showLoader: false,
                    timeByBranch: tempData?.BranchBytime || state?.chartdata[0]?.name
                }));
            }
            if (!tempData) {
                localStorage.setItem(
                    '_dashboard_',
                    JSON.stringify({
                        ...tempData,
                        workflowReturnReason: state.workFlowDataBarData[0]?.workflow
                    })
                );
            }
        }
        if (btTimeData) {
            setArray((st) => ({ ...st, byTimeBranch: btTimeData.branchShortName }));
        }
    }, [state.workFlowDataBarData, state.chartdata]);

    useEffect(() => {
        let tempData = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        if (state.technicianJobsData) {
            pullTechnicianJobsData(tempData?.selectedValueByTech || state?.chartdata[0]?.name);
        }

        if (!tempData.workflowReturnReason) {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...tempData,
                    workflowReturnReason: state.workFlowDataBarData[0]?.workflow || ''
                })
            );
        }
    }, [state.technicianJobsData, state.chartdata]);

    useEffect(() => {
        if (state?.assignedJobs && state.assignedJobs.length > 0) {
            let isJobAssigned = state.assignedJobs.filter((k) => k.userID === array.byAssignedUser);
            let allTotal = 0;
            if (state.assignedJobs.length > 0 && (array.byAssignedUser === 'Default' || isJobAssigned.length === 0)) {
                const allAssignedJobsData = state.assignedJobs.reduce((acc, obj) => {
                    allTotal += obj.total;
                    const index = acc.find((item) => item.workflowID === obj.workflowID);
                    index ? (index.total += obj.total) : acc.push({ ...obj });
                    return acc;
                }, []);

                setArray((st) => ({ ...st, assignedJobs: allAssignedJobsData, assignedJobsTotals: allTotal }));
            } else {
                const allAssignedJobsData = state.assignedJobs.filter((item) => {
                    if (item.userID === array.byAssignedUser) {
                        allTotal += item.total;
                    }
                    return item.userID === array.byAssignedUser;
                });

                setArray((st) => ({ ...st, assignedJobs: allAssignedJobsData, assignedJobsTotals: allTotal }));
            }
        }
    }, [state?.assignedJobs, array.byAssignedUser]);

    useEffect(() => {
        let branch = props.selectedBranch || 'Default';
        pullTechnicianJobsData(branch);
        findByTimeValues(branch);
        setArray((st) => ({
            ...st,
            byTimeBranch: branch,
            selectedValueByTech: branch,
            timeByBranch: branch !== 'Default' ? branch : state?.chartdata?.[0]?.name || st.timeByBranch
        }));
    }, [props.selectedBranch, state?.technicianJobsData, state?.sumOFByTimeForALL]);

    const pullTechnicianJobsData = (val) => {
        let tempLocalData = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        if (val && val !== 'Default') {
            let tempData = [...(state.technicianJobsData || [])].find((m) => m.bn == val) || [];
            let techJobsTotal = 0;
            if (tempData?.length > 0) {
                tempData.forEach((q) => {
                    techJobsTotal += q.total;
                });
            }
            setArray((st) => ({
                ...st,
                selectedValueByTech: val,
                selectedFilterTechData: tempData,
                techJobsTotal: techJobsTotal
            }));
            localStorage.setItem('_dashboard_', JSON.stringify({ ...tempLocalData, selectedValueByTech: val, BranchBytime: val }));
        } else {
            let allTechData = (state.technicianJobsData || []).flat();
            let techJobsTotal = 0;
            if (allTechData?.length > 0) {
                allTechData.forEach((q) => {
                    techJobsTotal += q.total;
                });
            }
            setArray((st) => ({
                ...st,
                selectedValueByTech: 'Default',
                selectedFilterTechData: allTechData,
                techJobsTotal: techJobsTotal
            }));
            localStorage.setItem('_dashboard_', JSON.stringify({ ...tempLocalData, selectedValueByTech: 'Default' }));
        }
    };

    const pullWorkflowRRdata = (value) => {
        let newArray = [];
        let keys = [];
        if (state.workFlowDataBarData) {
            let index = state.workFlowDataBarData.find((n) => n.workflow === value);
            if (index) {
                keys = Object.keys(index);
                newArray.push(index);
            }
            setArray((st) => ({
                ...st,
                workflowReturnReasonArray: newArray,
                keys: keys,
                workFlowRR: value
            }));
        }
    };

    let handleArray = (e) => {
        let workflowValue = e.target.value;
        let btTimeData = JSON.parse(localStorage.getItem('FiltterParams'));
        let tempData = JSON.parse(localStorage.getItem('_dashboard_'));
        localStorage.setItem('_dashboard_', JSON.stringify({ ...tempData, workflowReturnReason: workflowValue }));
        pullWorkflowRRdata(workflowValue);
        props.getbranchByOnchange(btTimeData?.branchShortName || 'Default', workflowValue);
    };

    let findByTimeValues = (val) => {
        let indexObj = {
            lessThan24HoursOld: 0,
            between1And5DaysOld: 0,
            between5And10DaysOld: 0,
            between10And20DaysOld: 0,
            between21And30DaysOld: 0,
            over30DaysOld: 0,
            preBooking: 0,
            between1to10Days: 0,
            between11And20Days: 0,
            between21And30Days: 0,
            overdueOver30DaysOld: 0,
            overdueArchived: 0,
            bn: ''
        };

        if (val === 'Default') {
            if (state?.sumOFByTimeForALL && state.sumOFByTimeForALL.length > 0) {
                let letNewData = state.sumOFByTimeForALL.reduce((acc, obj) => {
                    var index = acc.find((item) => item);
                    if (index) {
                        index.lessThan24HoursOld += obj?.lessThan24HoursOld || 0;
                        index.between1And5DaysOld += obj?.between1And5DaysOld || 0;
                        index.between5And10DaysOld += obj?.between5And10DaysOld || 0;
                        index.between10And20DaysOld += obj?.between10And20DaysOld || 0;
                        index.between21And30DaysOld += obj?.between21And30DaysOld || 0;
                        index.over30DaysOld += obj?.over30DaysOld || 0;
                        index.preBooking += obj?.preBooking || 0;
                        index.between1to10Days += obj?.between1to10Days || 0;
                        index.between11And20Days += obj?.between11And20Days || 0;
                        index.between21And30Days += obj?.between21And30Days || 0;
                        index.overdueOver30DaysOld += obj?.overdueOver30DaysOld || 0;
                        index.overdueArchived += obj?.overdueArchived || 0;
                        return acc;
                    }
                    acc.push({ ...obj });
                    return acc;
                }, []);
                let found = letNewData?.find((item) => item);
                if (found) {
                    indexObj = { ...found, bn: '' };
                }
            }
            setArray((st) => ({ ...st, byTimeObj: indexObj, byTimeBranch: val }));
        } else {
            if (state?.sumOFByTimeForALL && state.sumOFByTimeForALL.length > 0) {
                let found = state.sumOFByTimeForALL.find((n) => n?.bn === val);
                if (found) {
                    indexObj = { ...found };
                }
            }
            setArray((st) => ({ ...st, byTimeObj: indexObj, byTimeBranch: val }));
        }
    };

    const handleChangeByTime = (e) => {
        let tempData = JSON.parse(localStorage.getItem('_dashboard_'));
        let valueByTime = e.target.value;
        pullTechnicianJobsData(valueByTime);
        props.getbranchByOnchange(valueByTime);
        findByTimeValues(valueByTime);
        props.getPartReq(valueByTime);
        localStorage.setItem(
            'FiltterParams',
            JSON.stringify({
                branchShortName: valueByTime !== 'Default' ? valueByTime : ''
            })
        );
        if (valueByTime !== 'Default') {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...tempData,
                    BranchBytime: valueByTime,
                    selectedValueByTech: valueByTime,
                    BranchPartReq: valueByTime
                })
            );
        } else {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...tempData,
                    BranchPartReq: valueByTime
                })
            );
        }
    };
    // const handleChangeByPartsReq = (e) => {
    //     let tempData = JSON.parse(localStorage.getItem('_dashboard_'));
    //     let valueByTime = e.target.value;

    //     props.getPartReq(valueByTime);
    //     // if (valueByTime !== 'Default') {
    //     localStorage.setItem(
    //         '_dashboard_',
    //         JSON.stringify({
    //             ...tempData,
    //             BranchBytime: valueByTime !== 'Default' ? valueByTime : '',
    //             selectedValueByTech: valueByTime !== 'Default' ? valueByTime : ''
    //         })
    //     );
    //     //
    //     // }
    // };

    const handleTimeBranch = (e) => {
        let tempData = JSON.parse(localStorage.getItem('_dashboard_'));
        let valueByTimeBranch = e.target.value;
        setArray((st) => ({ ...st, timeByBranch: valueByTimeBranch }));

        localStorage.setItem('_dashboard_', JSON.stringify({ ...tempData, BranchBytime: valueByTimeBranch }));
    };
    const handleTechSelect = (e) => {
        let valueByTech = e.target.value;
        pullTechnicianJobsData(valueByTech);
    };

    const handleTechOnClick = (techObj) => {
        localStorage.setItem('FiltterParams', JSON.stringify({ branchShortName: techObj.bn }));
        let searchQuery = `&tid=${techObj.tid || ''}&bnm=${techObj.bn}&tnm=${techObj.name}&bid=${techObj.bid}`;
        history.push({
            pathname: '/techDashgrid',
            search: searchQuery,
            state: {}
        });
    };
    const handleTechCalender = (techObj) => {
        localStorage.setItem('FiltterParams', JSON.stringify({ branchShortName: techObj.bn }));
        let searchQuery = `&tid=${techObj.tid || ''}&bnm=${techObj.bn}&tnm=${techObj.name}&bid=${techObj.bid}`;
        history.push({
            pathname: '/TechnicianCalender',
            search: searchQuery,
            state: {}
        });
    };
    const handleBar = (val) => {
        if (val._reactName === 'onChange') {
            setArray((st) => ({ ...st, hourType: val.target.value }));
        } else {
            setArray((st) => ({ ...st, hourType: val }));
        }
    };
    const handleDate = (val) => {
        if (val._reactName === 'onChange') {
            setArray((st) => ({ ...st, assignedDate: val.target.value }));
        } else {
            setArray((st) => ({ ...st, assignedDate: val }));
        }
    };

    const DateObj = [
        {
            assignedDateObj: [
                { time: 1, label: 'Less Than 24Hr', BarColor: '5px solid #00F433', value: array.byTimeObj?.lessThan24HoursOld },
                { time: 2, label: '1 to 5 Days', BarColor: '5px solid #88EBA4', value: array.byTimeObj?.between1And5DaysOld },
                { time: 3, label: '5 to 10 Days', BarColor: '5px solid #FFBF00', value: array.byTimeObj?.between5And10DaysOld },
                { time: 4, label: '10 to 20 Days', BarColor: '5px solid #FFE28A', value: array.byTimeObj?.between10And20DaysOld },
                { time: 5, label: '20 to 30 Days', BarColor: '5px solid #bc4443', value: array.byTimeObj?.between21And30DaysOld },
                { time: 6, label: 'Over 30 Days', BarColor: '5px solid #F11C0E', value: array.byTimeObj?.over30DaysOld }
            ],
            OverDateObj: [
                { dueTime: 1, label: 'Pre Booking', BarColor: '5px solid #88EBA4', value: array.byTimeObj?.preBooking },
                { dueTime: 2, label: '1 to 10 Days', BarColor: '5px solid #FFBF00', value: array.byTimeObj?.between1to10Days },
                { dueTime: 3, label: '10 to 20 Days', BarColor: '5px solid #FFE28A', value: array.byTimeObj?.between11And20Days },
                { dueTime: 4, label: '20 to 30 Days', BarColor: '5px solid #bc4443', value: array.byTimeObj?.between21And30Days },
                { dueTime: 5, label: 'Over 30 Days', BarColor: '5px solid #F11C0E', value: array.byTimeObj?.overdueOver30DaysOld },
                { dueTime: -1, label: 'Archived', BarColor: '5px solid #F11C0E', value: array.byTimeObj?.overdueArchived }
            ]
        }
    ];

    const WipsDate = [
        { id: 2, name: 'Overdue WIPs' },
        { id: 1, name: 'Assigned Date' }
    ];

    const HoursData = [
        { id: 'remaining', name: 'Remaining Hours' },
        { id: 'clocked', name: 'Clocked Hours' },
        { id: 'allowed', name: 'Allowed Hours' }
    ];

    let Returns = props?.parts?.returnList;
    let partReqObj = props?.parts?.partReqList;
    let getDateObj = array.assignedDate == 1 ? DateObj[0].assignedDateObj : DateObj[0].OverDateObj;
    let getHoursObj = array.hourType === 'remaining' ? state.hoursRemaining : state.clockedHours;

    const handlePartReq = (techObj) => {
        let searchQuery = `?id=${techObj.id}&bn=${techObj.bn}`;
        history.push({
            pathname: '/RenaultPartReqs/PartReqs_By_Status',
            search: searchQuery
        });
    };

    const handleReturn = (techObj) => {
        let searchQuery = `?id=${techObj.statusID}`;
        history.push({
            pathname: `/Renault/PartReturn`,
            search: searchQuery
        });
    };

    const handlePieCard = (val) => {
        setArray((st) => ({ ...st, selectedPieChartType: val }));
    };

    const handleChangeAssignedUser = (e) => {
        setArray((st) => ({
            ...st,
            byAssignedUser: e.target.value
        }));
    };

    const redirectToAssignedJobs = (val, isAll) => {
        let assignedUser = '';
        if (array.byAssignedUser && array.byAssignedUser !== 'Default') {
            assignedUser = array.byAssignedUser;
        }

        let workflowId = isAll ? '' : val?.workflowID || '';
        let searchQuery = `workflowId=${workflowId}${assignedUser ? `&assignedUserID=${assignedUser}` : ''}&ProcessID=${props.processID || 1}`;
        history.push({
            pathname: '/AssignUserdashgrid',
            search: searchQuery,
            state: {}
        });
    };

    return (
        <Grid container spacing={2}>
            {/* *************Jobs By Technicians************* */}
            <Grid item xs={12} md={12}>
                <WipDashboardTechnician
                    state={state}
                    array={array}
                    handleTechCalender={handleTechCalender}
                    classes={classes}
                    handleTechOnClick={handleTechOnClick}
                    handleChangeByTime={handleChangeByTime}
                />
            </Grid>
            {/* *****************Branch / Assigned Jobs************** */}
            <Grid item xs={12} md={12} lg={4} xl={3}>
                <WipDashboardBranch
                    state={state}
                    array={array}
                    handlePieCard={handlePieCard}
                    handleChangeAssignedUser={handleChangeAssignedUser}
                    onChartClickHandler={props.onChartClickHandler}
                    redirectToAssignedJobs={redirectToAssignedJobs}
                />
            </Grid>

            {/* *****************Date************** */}
            <Grid item xs={12} md={12} lg={8} xl={9}>
                <EWIPDates
                    onChartClickHandler={props.onChartClickHandler}
                    state={state}
                    classes={classes}
                    WipsDate={WipsDate}
                    array={array}
                    handleDate={handleDate}
                    handleChangeByTime={handleChangeByTime}
                    getDateObj={getDateObj}
                />
            </Grid>
            {/* *****************Returns ************** */}
            <Grid item xs={12} md={12}>
                <PartReqCommon
                    header={'Returns'}
                    state={state}
                    array={array}
                    classes={classes}
                    handleChangeByPartsReq={handleChangeByTime}
                    List={Returns}
                    handleClick={handleReturn}
                />
            </Grid>

            {/* *****************Inspections************** */}
            <Grid item xs={12} md={12}>
                <Inspections
                    state={state}
                    header={'Inspections'}
                    selectedBranch={props.selectedBranch || array.byTimeBranch || state.selectedBranch}
                    handleChangeByBranch={handleChangeByTime}
                />
            </Grid>

            {/* *****************Part Req************** */}
            <Grid item xs={12} md={12}>
                <PartReqCommon
                    header={'Part Requisitions'}
                    state={state}
                    array={array}
                    classes={classes}
                    List={partReqObj}
                    handleClick={handlePartReq}
                    handleChangeByPartsReq={handleChangeByTime}
                />
            </Grid>

            {/* ********WorkFlow Graph******* */}
            {state.showHeaderLoader ? (
                <Grid item xs={12} lg={state.workflowData?.length > 6 ? 12 : 6}>
                    <div className={classes.root} style={{ width: '100%', height: 300, display: 'flex' }}>
                        <CircularProgress style={{ marginLeft: 'auto', marginRight: 'auto', alignSelf: 'center' }} />
                    </div>
                </Grid>
            ) : (
                state?.allHeaderData?.map((m, i) => {
                    if (m.bn === array.timeByBranch) {
                        return (
                            <Grid item xs={12} lg={state.workflowData?.length > 6 ? 12 : 6} key={m.bn || i}>
                                <Card className={classes.root}>
                                    <Hidden only={['xs']}>
                                        <Grid container justifyContent="space-between">
                                            <Grid item xs={12}>
                                                <Typography variant="h6" className="dashHeading">
                                                    Workflows By Branch ({array.timeByBranch || 'All Branch'})
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Hidden>
                                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                                        <Grid container justifyContent="space-between">
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                                    Workflows By Branch ({array.timeByBranch || 'All Branch'})
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Hidden>
                                    <div className="workflowChart">
                                        <ResponsiveContainer>
                                            <BarChart
                                                data={m}
                                                margin={{
                                                    top: 20,
                                                    right: width >= 600 ? 20 : 10,
                                                    left: width >= 600 ? -8 : -30,
                                                    bottom: width >= 600 ? 0 : 10
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis
                                                    dataKey="workflow"
                                                    textAnchor="end"
                                                    sclaeToFit="true"
                                                    verticalAnchor="start"
                                                    allowDataOverflow={false}
                                                    interval={0}
                                                    angle={width >= 600 ? '0' : '-20'}
                                                    style={{
                                                        fontSize: width >= 600 ? 12 : 6,
                                                        fontWeight: 700
                                                    }}
                                                />
                                                <YAxis style={{ fontSize: 12 }} />
                                                <Tooltip
                                                    contentStyle={{
                                                        background: 'rgba(0,0,0,0.8)',
                                                        color: 'white',
                                                        fontSize: 12,
                                                        fontWeight: 700
                                                    }}
                                                    position={{ x: 30, y: 20 }}
                                                />
                                                {width >= 600 ? <Legend /> : null}
                                                {state?.allHeaderDataKeys?.map((n, i) => {
                                                    return (
                                                        n !== 'name' &&
                                                        n !== 'workflow' &&
                                                        n !== 'workflowID' && (
                                                            <Bar key={n || i} dataKey={n} fill={setObject[n]} barSize={10} style={{ cursor: 'pointer' }}>
                                                                {m.map((entry, index) => {
                                                                    return (
                                                                        <Cell
                                                                            key={index}
                                                                            onClick={() =>
                                                                                props.onChartClickHandler(
                                                                                    {
                                                                                        workflowID: entry.workflowID,
                                                                                        workflow: entry.workflow,
                                                                                        bn: entry.name,
                                                                                        time: timenumber[n]
                                                                                    },
                                                                                    true
                                                                                )
                                                                            }
                                                                        />
                                                                    );
                                                                })}
                                                            </Bar>
                                                        )
                                                    );
                                                })}
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </Card>
                            </Grid>
                        );
                    }
                    return null;
                })
            )}

            {/* ********* Return Reason By Workflow ********* */}
            <Grid item xs={12} lg={state.workflowData?.length > 6 ? 12 : 6}>
                {state.showReturnReasonLoader ? (
                    <div className={classes.root} style={{ width: '100%', height: 300, display: 'flex' }}>
                        <CircularProgress style={{ marginLeft: 'auto', marginRight: 'auto', alignSelf: 'center' }} />
                    </div>
                ) : (
                    <Card className={classes.root}>
                        <Hidden only={['xs']}>
                            <Grid container justifyContent="space-between">
                                <Grid item xs={12} sm={8} lg={8}>
                                    <Typography variant="h6" className="dashHeading">
                                        Return Reason By Workflow ({!array?.byTimeBranch ? 'All Branch' : array?.byTimeBranch})
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} lg={4}>
                                    <div style={{ float: 'right' }}>
                                        <select onChange={handleArray} className="selectclass" value={array.workFlowRR}>
                                            {state?.workflowData.map((j, i) => (
                                                <option key={i} value={j.name}>
                                                    {j.name}{' '}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Grid>
                            </Grid>
                        </Hidden>
                        <Hidden only={['sm', 'md', 'lg', 'xl']}>
                            <Grid container justifyContent="space-between">
                                <Grid item xs={12} sm={8} md={8} lg={10}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                        <Typography variant="h6" className="dashHeading">
                                            Return Reason By Workflow ({!array?.byTimeBranch ? 'All Branch' : array?.byTimeBranch})
                                        </Typography>
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <div
                                        style={{
                                            margin: '0px 20px',
                                            textAlign: 'left'
                                        }}
                                    >
                                        <span className="lableFont">Workflow</span>
                                        <select onChange={handleArray} className="selectclass" value={array.workFlowRR}>
                                            {state?.workflowData.map((j, i) => (
                                                <option key={i} value={j.name}>
                                                    {j.name}{' '}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Grid>
                            </Grid>
                        </Hidden>

                        <div className="workflowChart">
                            {array.workflowReturnReasonArray.length > 0 ? (
                                <ResponsiveContainer>
                                    <BarChart
                                        data={array.workflowReturnReasonArray}
                                        width={300}
                                        margin={{
                                            top: 20,
                                            right: width >= 600 ? 20 : 10,
                                            left: width >= 600 ? -8 : -30,
                                            bottom: width >= 600 ? 0 : 10
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis
                                            dataKey="workflow"
                                            verticalAnchor="start"
                                            allowDataOverflow={false}
                                            interval={0}
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 700
                                            }}
                                        />
                                        <YAxis style={{ fontSize: 12 }} />
                                        <Tooltip
                                            contentStyle={{
                                                background: 'rgba(0,0,0,0.8)',
                                                color: 'white',
                                                fontSize: 12,
                                                fontWeight: 700
                                            }}
                                            position={{ x: 30, y: 20 }}
                                        />

                                        {array?.keys?.map((m, i) => {
                                            let color = state?.returnReasonColors?.find((n) => n.rr === m);
                                            return (
                                                m !== 'name' &&
                                                m !== 'workflowID' &&
                                                m !== 'workflow' && (
                                                    <Bar
                                                        key={m || i}
                                                        dataKey={m}
                                                        fill={color?.color || '#183B68'}
                                                        barSize={width >= 600 ? 40 : 15}
                                                        layout="vertical"
                                                        height={20}
                                                    >
                                                        <LabelList dataKey={m} position="top" />
                                                        {array?.workflowReturnReasonArray?.map((entry, index) => {
                                                            return (
                                                                <Cell
                                                                    key={index}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() =>
                                                                        props.onChartClickHandler(
                                                                            {
                                                                                workflowID: entry.workflowID,
                                                                                returnReason: m,
                                                                                bn: entry.name
                                                                            },
                                                                            true
                                                                        )
                                                                    }
                                                                />
                                                            );
                                                        })}
                                                    </Bar>
                                                )
                                            );
                                        })}
                                    </BarChart>
                                </ResponsiveContainer>
                            ) : (
                                <Grid container justifyContent="center" alignContent="center">
                                    <h5>No chart data Found</h5>
                                </Grid>
                            )}
                        </div>
                    </Card>
                )}
            </Grid>
        </Grid>
    );
};

export default DashboardCharts;
